<template>
  <v-card tile id="sentEmails">
    <v-card-title>
      <v-row >
        <v-toolbar flat>
          <v-toolbar-title class="col-6">{{
            resx.labels.sentEmails
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            :label="resx.labels.search"
            single-line
            hide-details
            v-model="search"
          >
          </v-text-field>
        </v-toolbar>
      </v-row >
    </v-card-title>
    <v-card-text class="table-container fixed-header">
      <v-row>
        <v-col class="col-9">
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="col-3">
          <v-row
            class="px-2 actionButton "
            v-if="
              $store.state.auth.user.roles[0] ==
                $store.state.constants.roles.SYS_ADMIN
            "
          >
            <v-row justify="center">
              <v-dialog
                max-width="800"
                v-model="dialog"
                persistent
                :fullscreen="$vuetify.breakpoint.smAndDown"
                @keydown.esc="dialog = false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="onOpen()"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Enviar emails
                  </v-btn>
                </template>
                <v-card tile>
                  <v-app-bar dark flat color="primary">
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                    <span class="title">{{
                      "Envío manual de emails"
                    }}</span>
                  </v-app-bar>
                  <v-container >
                    <v-row align="center">
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <v-select
                          :label="resx.labels.company"
                          :items="companyOptions"
                          item-text="name"
                          item-value="_id"
                          v-model="selectedCompany"
                          :loading="loadingCompanies"
                          :no-data-text="resx.messages.noSelectorDataAvailable"
                        />
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <v-select
                          label="Tipo de recordatorio"
                          v-model="emailType"
                          :items="showEmailType"
                          @input="changeMessage(emailType)"
                        />
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <datepicker-component
                          :label="`Selecionar fecha de envío`"
                          :left="true"
                          @input="referenceDate = $event"
                          v-model="referenceDate"
                        />
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Título del email:"
                          v-model="emailSubject"
                        />
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Cantidad maxima de email a enviar"
                          placeholder="Vacío = sin límite"
                          v-model="maxItems"
                        />
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Enviar a"
                          v-model="forceEmailTo"
                          :error-messages="forceEmailToError"
                          hint="El envío va exclusivamente a esta dirección"
                          persistent-hint
                        />
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="dialog = false">{{ resx.labels.cancel }}</v-btn>
                      <v-btn
                        @click="dialog = send()"
                        class="primary"
                        type="submit"
                        :disabled="!isValidForceEmailTo"
                      >{{
                        resx.labels.ok
                      }}</v-btn>
                    </v-card-actions>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
      <!-- ultima -->
      <v-row column fill-height class="scrollable">
        <v-col fill-height class="scrollable">
          <v-data-table
            resizable=true
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="emails"
            :server-items-length="total"
            :options.sync="options"
            :loading=loading
            :no-data-text="resx.messages.noEmailsSent"
            height="auto"
            ref="dataTable"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            loading-text=""
          >
            <template v-slot:loading>
              <BarLoader :isLoading="loading" />
            </template>
            <template v-slot:item._id="{ item }">
              <div class="sent-at">
                {{ sentAtDate(item._id) }}<br />{{ sentAtTime(item._id) }}
              </div>
            </template>
            <template v-slot:item.emailType="{ item }">
              <div class="justify-center">{{ purposeText(item.emailType) }}</div>
            </template>
            <template v-slot:item.sendType="{ item }">
              <v-chip
                small
                :outlined="!isTestSendType(item.sendType)"
                :color="sendTypeColor(item.sendType)"
                :text-color="isTestSendType(item.sendType) ? 'white' : undefined"
              >{{ sendTypeText(item.sendType) }}</v-chip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from "moment";
import companyService from "@/services/CompanyService";
import sentEmailsService from "@/services/SentEmailsService";
import emailTemplateService from "@/services/EmailTemplateService";
import datepickerComponent from "@/components/common/datepicker.vue";
import BarLoader from "@/components/common/bar-loader.vue";

const SEARCH_DEBOUNCE_MS = 400;

// Los cuatro valores que trae sentEmails.sendType (SEND_TYPES en
// utils/constants.js del backend). 'manual' y 'scheduled' son el camino
// viejo; 'delivery' y 'test' son los de un Envío configurable. No hay lookup
// del backend para esto -a diferencia de los propósitos-, asi que se escribe
// el mapa aca.
const SEND_TYPE_MANUAL = "manual";
const SEND_TYPE_SCHEDULED = "scheduled";
const SEND_TYPE_DELIVERY = "delivery";
const SEND_TYPE_TEST = "test";

const SEND_TYPE_TEXT = {
  [SEND_TYPE_MANUAL]: "Manual (anterior)",
  [SEND_TYPE_SCHEDULED]: "Automático (anterior)",
  [SEND_TYPE_DELIVERY]: "Envío automático",
  [SEND_TYPE_TEST]: "Prueba"
};

// Las filas anteriores a que existiera sendType. No son un origen distinto:
// son del camino viejo, igual que 'scheduled'/'manual', pero no dejaron rastro
// de cual.
const SEND_TYPE_UNKNOWN_TEXT = "Anterior";

// El color no es solo estetico: es lo que hace que una fila de prueba se
// distinga de un correo real de un vistazo, sin tener que leer el texto del
// chip. Las filas viejas sin sendType (anteriores a este campo) caen en el
// mismo gris que 'scheduled' Y muestran SEND_TYPE_UNKNOWN_TEXT: sin ese texto
// el chip salia vacio, que es justo la celda en blanco que esta columna vino a
// eliminar.
const SEND_TYPE_COLOR = {
  [SEND_TYPE_MANUAL]: "grey darken-1",
  [SEND_TYPE_SCHEDULED]: "grey darken-1",
  [SEND_TYPE_DELIVERY]: "primary",
  [SEND_TYPE_TEST]: "warning"
};

export default {
  name: "sent-emails",
  components: {
    datepickerComponent,
    BarLoader
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      search: "",
      searchTimer: null,
      // Descarta respuestas que llegan fuera de orden: con la busqueda
      // debounceada una consulta lenta puede volver despues de una posterior.
      requestId: 0,
      options: {
        page: 1,
        itemsPerPage:
          parseInt(localStorage.getItem(this.$options.name + "_itemsPerPage")) || 15
      },
      // Ultimo pedido efectivamente disparado, para no repetirlo.
      lastQueryKey: null,
      total: 0,
      headers: [
        {
          class: "hidden-sm-and-down",
          text: resx.labels.date,
          // _id y no referenceDate: el instante real del envio sale del
          // timestamp embebido en el ObjectId. Ver el comentario de sentAtMoment().
          value: "_id",
          // 110px alcanzan para "00/00/0000"; con el nowrap de la celda quedan
          // exactamente dos lineas.
          width: 110,
          sortable: false
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.type,
          value: "emailType",
          sortable: false
        },
        {
          class: "hidden-sm-and-down",
          text: "Origen",
          // sendType, no un campo de solo lectura calculado: distingue de que
          // camino salio la fila (ver sendTypeLabel/sendTypeColor).
          value: "sendType",
          sortable: false
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.contractor,
          value: "contractorCompany.contractor.name",
          sortable: false
        },
        {
          class: "hidden-sm-and-down",
          text: resx.messages.dueDated,
          value: "delayedObligations",
          sortable: false
        },
        {
          class: "hidden-sm-and-down",
          text: resx.messages.futureDueDate,
          value: "nextMonthObligations",
          sortable: false
        }
      ],
      emails: [],
      // Lookup de propósitos legibles, el mismo que usa la pantalla de
      // Envíos: evita mantener dos listas de lo mismo (ver purposeText).
      purposes: [],
      maxItems: 1,
      showEmailType: [
        { text: resx.labels.daily, value: "daily" },
        { text: resx.labels.monthly, value: "monthly" }
      ],
      showEmailSubject: null,
      companies: [],
      loadingCompanies: false,
      // null = "Todas", que es lo que hace el envio automatico.
      selectedCompany: null,
      emailType: null,
      referenceDate: null,
      forceEmailTo: null,
      emailSubject: null,
      dialog: false,
      loading: true
    };
  },
  computed: {
    companyOptions() {
      return [{ _id: null, name: "Todas" }].concat(this.companies);
    },
    // "Enviar a" es obligatorio a proposito: esta pantalla es de prueba y el
    // envio se saltea la guarda de ya-enviado (manda send_type=manual). Sin
    // direccion, ese reenvio le llegaria a los contratistas reales y duplicaria
    // lo ya mandado.
    isValidForceEmailTo() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.forceEmailTo || "").trim());
    },
    forceEmailToError() {
      if (!this.forceEmailTo) return "Obligatorio: el envío es de prueba";
      return this.isValidForceEmailTo ? null : "Correo inválido";
    }
  },
  // Se pide el lookup de propositos apenas se monta la pantalla, a diferencia
  // de loadCompanies() que espera a que se abra el dialogo: la tabla de abajo
  // lo necesita para la columna de tipo, no solo el dialogo de envio manual.
  async created() {
    await this.loadPurposes();
  },
  watch: {
    // v-data-table emite update:options al montarse, asi que esta es tambien
    // la carga inicial. No hace falta pedir nada desde mounted().
    options: {
      handler() {
        localStorage.setItem(
          this.$options.name + "_itemsPerPage",
          this.options.itemsPerPage
        );
        this.loadEmails();
      },
      deep: true
    },
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        // Volver a la pagina 1 ya dispara el watcher de options; llamar a
        // loadEmails aca ademas pediria la misma pagina dos veces.
        if (this.options.page !== 1) {
          this.options.page = 1;
        } else {
          this.loadEmails();
        }
      }, SEARCH_DEBOUNCE_MS);
    }
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    // El instante real del envio sale del timestamp que el ObjectId lleva
    // embebido en sus primeros 4 bytes (segundos Unix, en hexadecimal).
    //
    // Se usa eso y no `creationDate` por dos motivos, los dos documentados en
    // el comentario de SORT en src/domains/sentEmails.domain.js del backend:
    // ese campo se agrego despues y falta en todo el historico, y su valor
    // viene corrido porque se guarda formateando el reloj de Argentina como
    // texto. El _id existe en todas las filas, es exacto, y es el mismo dato
    // con el que esta pantalla ya ordena cronologicamente.
    sentAtMoment(id) {
      if (typeof id !== "string" || id.length < 8) {
        return null;
      }
      const seconds = parseInt(id.substring(0, 8), 16);
      if (isNaN(seconds)) {
        return null;
      }
      return moment(seconds * 1000);
    },
    sentAtDate(id) {
      const sentAt = this.sentAtMoment(id);
      return sentAt && sentAt.isValid() ? sentAt.format("DD/MM/YYYY") : "";
    },
    sentAtTime(id) {
      const sentAt = this.sentAtMoment(id);
      return sentAt && sentAt.isValid() ? sentAt.format("HH:mm") : "";
    },
    async loadPurposes() {
      try {
        this.purposes = await emailTemplateService.purposes();
      } catch (error) {
        // Sin el lookup se cae al valor crudo en purposeText: no bloquea la
        // pantalla por esto.
        this.purposes = [];
      }
    },
    // El texto visible sale del lookup del backend (el mismo que usa la
    // pantalla de Envíos), no de una lista propia: dos listas que hay que
    // mantener en acuerdo terminan en desacuerdo.
    purposeText(value) {
      if (!value) { return ""; }
      const purpose = this.purposes.find(p => p.value === value);
      return (purpose && purpose.text) || value;
    },
    isTestSendType(sendType) {
      return sendType === SEND_TYPE_TEST;
    },
    sendTypeText(sendType) {
      return SEND_TYPE_TEXT[sendType] || sendType || SEND_TYPE_UNKNOWN_TEXT;
    },
    sendTypeColor(sendType) {
      return SEND_TYPE_COLOR[sendType] || "grey darken-1";
    },
    async loadEmails() {
      // v-data-table completa options por partes al montarse (sortBy, sortDesc,
      // groupBy...), y cada mutacion despierta al watcher deep. Sin esta guarda
      // el montaje dispara el mismo pedido varias veces.
      const queryKey = [this.options.page, this.options.itemsPerPage, this.search].join("|");
      if (queryKey === this.lastQueryKey) {
        return;
      }
      this.lastQueryKey = queryKey;

      this.requestId += 1;
      const currentRequest = this.requestId;
      this.loading = true;
      try {
        const response = await sentEmailsService.getEmails({
          page: this.options.page,
          limit: this.options.itemsPerPage,
          search: this.search
        });
        if (currentRequest !== this.requestId) {
          return;
        }
        this.emails = response.items;
        this.total = response.total;
      } catch (error) {
        // Se libera la guarda para que el mismo pedido pueda reintentarse.
        this.lastQueryKey = null;
        throw error;
      } finally {
        if (currentRequest === this.requestId) {
          this.loading = false;
        }
      }
    },
    onOpen() {
      this.emailType = 0;
      this.referenceDate = null;
      this.emailSubject = null;
      this.forceEmailTo = null;
      this.selectedCompany = null;
      this.maxItems = 1;
      this.loadCompanies();
    },
    // Se piden al abrir el dialogo y una sola vez: la pantalla de listado no
    // necesita las empresas, y traerlas al montar la encarecia sin motivo.
    async loadCompanies() {
      if (this.companies.length || this.loadingCompanies) {
        return;
      }
      this.loadingCompanies = true;
      try {
        this.companies = await companyService.getCompanies(true);
      } finally {
        this.loadingCompanies = false;
      }
    },
    send() {
      // Vacio = sin limite. El default es 1 para que un envio manual no
      // dispare toda la tanda por descuido.
      if (this.maxItems === "" || this.maxItems === undefined) {
        this.maxItems = null;
      }
      var referenceDate = moment(this.referenceDate).format("DD/MM/YYYY");
      let forceEmailToParam = this.forceEmailTo
        ? "&force_email_to=" + this.forceEmailTo
        : "";
      let emailSubjectParam = this.emailSubject
        ? "&email_subject=" + this.emailSubject
        : "";
      let companyParam = this.selectedCompany
        ? "&company_id=" + this.selectedCompany
        : "";
      let url =
        "http://noataga.localhost/api/workers/notify-contractors/" +
        this.emailType +
        "?send_type=manual" +
        "&reference_date=" +
        referenceDate +
        "&max_items=" +
        this.maxItems +
        forceEmailToParam +
        emailSubjectParam +
        companyParam;
      window.open(url, "_blank");
    },
    changeMessage() {
      // Se deja vacio a proposito: si no se manda email_subject, el asunto lo
      // arma el backend con la fecha del dia (mail.service.js). Prellenarlo
      // pisaba ese default y los envios forzados salian sin fecha.
      this.emailSubject = null;
    }
  }
};
</script>

<style lang="scss">
#sentEmails {
  // La fecha de envio va en dos lineas: fecha arriba, hora abajo. El nowrap
  // impide que alguna de las dos se parta y agregue una tercera linea.
  .sent-at {
    white-space: nowrap;
    line-height: 1.3;
  }
}
</style>
